/**
 * wishlist-page.js — trang Danh sách yêu thích (mục 23): vẽ danh sách từ
 * WBStore.wishlist, badge tình trạng kho / giá giảm, "Thêm tất cả vào giỏ", "Chia sẻ".
 *
 * Markup cần: [data-wishlist-page] chứa ul[data-wishlist-list], [data-wishlist-empty],
 * [data-wishlist-page-count], [data-wishlist-actions] > [data-wishlist-share] +
 * [data-wishlist-add-all]. Mỗi dòng in GIỐNG HỆT bản HTML tĩnh: nút "Thêm vào giỏ" để
 * cart.js ([data-add-to-cart]) tự bắt; nút tim [data-wishlist-remove] do file này xử lý
 * (không dùng [data-wishlist-toggle] vì wishlist.js vẽ lại aria-label chung chung
 * "Bỏ khỏi yêu thích", mất tên chai). Danh sách vẽ lại mỗi khi có sự kiện wb:wishlist.
 *
 * Giá + tồn kho đọc từ catalog (số HIỆN TẠI); giá lúc lưu là savedPrice trong
 * localStorage (store.js ghi lúc bấm tim). So hai số mới biết "Giảm … từ khi lưu".
 *
 * WP: YITH in danh sách bằng PHP (woocommerce/wishlist-view.php), chia sẻ và
 * "add all to cart" có sẵn trong plugin — xoá file này.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var LOW_STOCK = 5; // từ 5 chai trở xuống thì báo "Chỉ còn N chai"

    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    var list = root.querySelector('[data-wishlist-list]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var count = root.querySelector('[data-wishlist-page-count]');
    var actions = root.querySelector('[data-wishlist-actions]');
    var addAll = root.querySelector('[data-wishlist-add-all]');
    var share = root.querySelector('[data-wishlist-share]');

    // Đăng ký "báo khi có hàng" chỉ sống trong phiên trang — bản demo không có server gửi mail
    var notified = {};
    // Vị trí dòng vừa bị bỏ: dòng biến mất khỏi DOM thì focus rơi về <body>,
    // người dùng bàn phím mất chỗ đứng — trả focus cho dòng kế tiếp.
    var focusIndex = -1;

    function store() {
        return window.WBStore;
    }

    function toast(text, options) {
        if (window.WBToast) window.WBToast.show(text, options);
    }

    function esc(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
    }

    // Ghép bản lưu với catalog: chai không có trong catalog mẫu (lưu từ data-* của card)
    // vẫn vẽ được bằng chính dữ liệu đã lưu, coi như còn hàng.
    function row(item) {
        var live = (window.WBCatalog && window.WBCatalog.get(item.id)) || {};
        var price = live.price != null ? live.price : item.price;
        var stock = live.stock != null ? live.stock : item.stock;
        return {
            item: item,
            name: live.name || item.name,
            price: Number(price) || 0,
            saved: Number(item.savedPrice) || 0,
            stock: stock == null ? null : Number(stock),
            flag: live.flag || item.flag,
            country: live.country || item.country,
            region: live.region || item.region,
            year: live.year || item.year,
            image: item.image || live.image || 'images/products/bottle.png',
            url: item.url || live.url || 'single-product.html'
        };
    }

    function badges(r) {
        var html = '';
        if (r.stock === 0) {
            var on = !!notified[r.item.id];
            html += '<span class="badge badge--muted badge--sm">Hết hàng</span>' +
                '<button class="wishlist-line__notify" type="button" aria-pressed="' + on + '" data-wishlist-notify>' +
                '<i class="ph-bold ' + (on ? 'ph-check-circle' : 'ph-bell-ringing') + '" aria-hidden="true"></i>' +
                (on ? 'Sẽ báo khi có hàng' : 'Báo khi có hàng') + '</button>';
        } else if (r.stock != null && r.stock <= LOW_STOCK) {
            html += '<span class="badge badge--warning badge--sm">Chỉ còn ' + r.stock + ' chai</span>';
        } else {
            html += '<span class="badge badge--success badge--sm">Còn hàng</span>';
        }
        if (r.saved > r.price) {
            html += '<span class="badge badge--warning badge--sm"><i class="ph-fill ph-trend-down" aria-hidden="true"></i>Giảm ' +
                store().money(r.saved - r.price) + ' từ khi lưu</span>';
        }
        return html;
    }

    function origin(r) {
        var parts = [r.country, r.region, r.year].filter(Boolean).map(function (part) {
            return '<span>' + esc(part) + '</span>';
        });
        if (!parts.length) return '';
        return '<p class="origin">' +
            (r.flag ? '<img class="flag flag--sm" src="images/flags/' + esc(r.flag) + '.png" alt="" width="40" height="27" loading="lazy" />' : '') +
            parts.join('<span class="origin__sep" aria-hidden="true">·</span>') + '</p>';
    }

    function line(r) {
        var out = r.stock === 0;
        var name = esc(r.name);
        // data-name/price/image: wishlist.js và cart.js dựng bản chụp từ đây khi chai
        // không có trong catalog mẫu — thiếu tên thì WBStore.product() trả null, nút "chết".
        return '<li class="wishlist-line' + (out ? ' is-out-of-stock' : '') + '" data-product data-product-id="' + esc(r.item.id) + '"' +
            ' data-name="' + name + '" data-price="' + r.price + '" data-image="' + esc(r.image) + '">' +
            '<a class="thumb thumb--md" href="' + esc(r.url) + '" tabindex="-1" aria-hidden="true">' +
            '<img src="' + esc(r.image) + '" alt="" width="600" height="800" loading="lazy" /></a>' +
            '<div class="wishlist-line__info">' +
            '<h3 class="wishlist-line__name"><a href="' + esc(r.url) + '">' + name + '</a></h3>' +
            origin(r) +
            '<div class="wishlist-line__status">' + badges(r) + '</div></div>' +
            '<div class="wishlist-line__foot">' +
            '<span class="wishlist-line__price money">' + store().money(r.price) + '</span>' +
            '<div class="wishlist-line__actions">' +
            '<button class="btn btn--primary btn--compact" type="button" aria-label="' +
            (out ? name + ' đang hết hàng' : 'Thêm ' + name + ' vào giỏ') + '"' + (out ? ' disabled' : '') + ' data-add-to-cart>' +
            '<i class="ph-bold ph-shopping-cart-simple" aria-hidden="true"></i>Thêm vào giỏ</button>' +
            '<button class="wishlist-line__remove" type="button" aria-label="Bỏ ' + name + ' khỏi yêu thích" data-wishlist-remove>' +
            '<i class="ph-fill ph-heart" aria-hidden="true"></i></button>' +
            '</div></div></li>';
    }

    function rows() {
        return store().wishlist.items().map(row);
    }

    function render() {
        var data = rows();
        var inStock = data.filter(function (r) {
            return r.stock !== 0;
        }).length;

        list.innerHTML = data.map(line).join('');
        list.hidden = !data.length;
        if (empty) empty.hidden = !!data.length;
        if (actions) actions.hidden = !data.length;
        if (count) count.textContent = String(data.length);
        // Cả danh sách hết hàng thì nút "Thêm tất cả" vô nghĩa — tắt hẳn thay vì bấm rồi báo lỗi
        if (addAll) addAll.disabled = !inStock;

        restoreFocus();
    }

    function restoreFocus() {
        if (focusIndex < 0) return;
        var buttons = list.querySelectorAll('[data-wishlist-remove]');
        var target = buttons[Math.min(focusIndex, buttons.length - 1)] || (empty && empty.querySelector('a'));
        focusIndex = -1;
        if (target) target.focus();
    }

    list.addEventListener('click', function (event) {
        var remove = event.target.closest('[data-wishlist-remove]');
        if (remove) {
            var line = remove.closest('[data-product]');
            // Ghi vị trí trước khi xoá: WBStore phát wb:wishlist đồng bộ nên render()
            // chạy ngay trong lệnh remove() bên dưới và đã biết cần trả focus vào đâu.
            focusIndex = [].slice.call(list.querySelectorAll('[data-wishlist-remove]')).indexOf(remove);
            store().wishlist.remove(line.getAttribute('data-product-id'));
            toast('Đã bỏ ' + line.getAttribute('data-name') + ' khỏi danh sách yêu thích');
            return;
        }

        var notify = event.target.closest('[data-wishlist-notify]');
        if (!notify || notify.getAttribute('aria-pressed') === 'true') return;
        var holder = notify.closest('[data-product]');
        var id = holder.getAttribute('data-product-id');
        notified[id] = true;
        notify.setAttribute('aria-pressed', 'true');
        notify.innerHTML = '<i class="ph-bold ph-check-circle" aria-hidden="true"></i>Sẽ báo khi có hàng';
        toast('WINEBOSS sẽ báo cho bạn khi ' + holder.getAttribute('data-name') + ' về hàng', {
            icon: 'ph-fill ph-bell-ringing'
        });
    });

    // ----- Thêm tất cả vào giỏ: chỉ các chai còn hàng, mỗi chai 1 -----
    function addAllToCart() {
        var s = store();
        var added = 0;
        rows().forEach(function (r) {
            if (r.stock === 0) return;
            var snap = s.product(r.item.id) || Object.assign({}, r.item);
            delete snap.savedPrice;
            s.cart.add(snap, 1);
            added += 1;
        });
        if (!added) return;
        toast('Đã thêm ' + added + ' chai vào giỏ hàng', {
            icon: 'ph-fill ph-check-circle',
            action: { label: 'Xem giỏ', href: 'cart.html' }
        });
    }

    // ----- Chia sẻ: link trang kèm danh sách id -----
    // WP: YITH sinh link riêng cho từng danh sách (?wishlist-id=…). Bản tĩnh chỉ cần
    // một URL đọc được để demo thao tác copy.
    function shareUrl() {
        var ids = store().wishlist.items().map(function (item) {
            return item.id;
        });
        return window.location.href.split('#')[0].split('?')[0] + '?ids=' + encodeURIComponent(ids.join(','));
    }

    // execCommand('copy') cho trình duyệt cũ / trang không ở secure context —
    // navigator.clipboard chỉ có trên https (và localhost).
    function legacyCopy(text) {
        var area = document.createElement('textarea');
        var ok = false;
        area.value = text;
        area.setAttribute('readonly', '');
        area.className = 'visually-hidden';
        document.body.appendChild(area);
        area.select();
        try {
            ok = document.execCommand('copy');
        } catch (e) {
            ok = false;
        }
        document.body.removeChild(area);
        return ok;
    }

    function copied(ok) {
        toast(ok ? 'Đã sao chép link danh sách — gửi cho người thân làm gợi ý quà nhé' : 'Chưa sao chép được, hãy copy link trên thanh địa chỉ', {
            icon: ok ? 'ph-bold ph-link' : 'ph-bold ph-warning-circle'
        });
    }

    function copyLink() {
        var url = shareUrl();
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(url).then(
                function () {
                    copied(true);
                },
                function () {
                    copied(legacyCopy(url));
                }
            );
            return;
        }
        copied(legacyCopy(url));
    }

    function init() {
        if (!store()) return;
        render();
        document.addEventListener('wb:wishlist', render);
        if (addAll) addAll.addEventListener('click', addAllToCart);
        if (share) share.addEventListener('click', copyLink);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
